import request from '@/utils/request';

//查询决策图复合
export function getDiagramApprovalList(values) {
  return request('/decision/diagram-approval/approval', {
    method: 'GET',
    params: values,
  });
}
//通过
export function pass(id) {
  return request(`/decision/diagram-approval/pass/${id}`, {
    method: 'PUT',
  });
}
//拒绝
export function reject(id) {
  return request(`/decision/diagram-approval/reject/${id}`, {
    method: 'PUT',
  });
}
